import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { RegionalPricingManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/regional-pricing")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <RegionalPricingManagement />
    </RouteGuard>
  ),
});
